var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sexy-santa-banner" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 sexy-santa-banner-content-wrapper d-flex" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sexy-santa-banner-content d-flex text-white" },
              [
                _c(
                  "div",
                  { staticClass: "sexy-santa-banner-text px-0 px-sm-4" },
                  [
                    _c("div", { staticClass: "sexy-santa-banner-title" }, [
                      _vm._v(_vm._s(_vm.translate.home.sexySanta.title))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sexy-santa-banner-description" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.translate.home.sexySanta.bannerText) +
                            " "
                        ),
                        _c("strong", [_vm._v("400€!")])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sexy-santa-banner-button mb-3 mb-sm-0 mt-2" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-white btn-small px-5 px-sm-4",
                        attrs: { href: _vm.regionRelativeUrl("/sexy-santa/") }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.translate.home.sexySanta.enter) +
                            "\n                        "
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sexy-santa-banner-image" }, [
      _c("img", { attrs: { src: "/images/sexy-santa/sexy-santa-banner.png" } })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-057820a8", { render: render, staticRenderFns: staticRenderFns })
  }
}